"use strict";
exports.__esModule = true;
exports.MissedDeliveryReason = exports.Setting = exports.Intensity = exports.Status = void 0;
/*
 * Service status values supported by API
 */
var Status;
(function (Status) {
    Status["AsPlanned"] = "as_planned";
    Status["WithChanges"] = "with_changes";
    Status["NotDelivered"] = "not_delivered";
})(Status = exports.Status || (exports.Status = {}));
/*
 * Service intensity values supported by API
 */
var Intensity;
(function (Intensity) {
    Intensity["Individual"] = "individual";
    Intensity["Group"] = "group";
})(Intensity = exports.Intensity || (exports.Intensity = {}));
/*
 * Service intensity values supported by API
 */
var Setting;
(function (Setting) {
    Setting["AgencySponsoredGroup"] = "agency_sponsored_group";
    Setting["ChildCareCenter"] = "child_care_center";
    Setting["ClinicVisit"] = "clinic_visit";
    Setting["CommunityGroup"] = "community_group";
    Setting["Correspondence"] = "correspondence";
    Setting["HomeVisit"] = "home_visit";
    Setting["OfficeVisit"] = "office_visit";
    Setting["PhoneCall"] = "phone_call";
    Setting["Telepractice"] = "telepractice";
})(Setting = exports.Setting || (exports.Setting = {}));
/*
 * EFC values supported by API
 */
var MissedDeliveryReason;
(function (MissedDeliveryReason) {
    MissedDeliveryReason["EFCLossOfContact"] = "efc.loss_of_contact";
    MissedDeliveryReason["EFCFamilyNoShow"] = "efc.family_no_show";
    MissedDeliveryReason["EFCFamilyCancelled"] = "efc.family_cancelled";
    MissedDeliveryReason["ProviderSick"] = "provider_sick";
    MissedDeliveryReason["ProviderNotAvailable"] = "provider_not_available";
    MissedDeliveryReason["AgencyDelay"] = "agency_delay";
    MissedDeliveryReason["Other"] = "other";
})(MissedDeliveryReason = exports.MissedDeliveryReason || (exports.MissedDeliveryReason = {}));
//# sourceMappingURL=index.js.map